<template>
  <WebChapterTemplate
    page-title="《中国新闻年鉴》"
    section-label="传播与平台"
    section-route="/lanhu_chuanboyupingtai"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
  >
    <section class="page-section page-section--intro">
      <div class="intro-grid">
        <div class="intro-copy">
          <h2 class="section-title">《中国新闻年鉴》</h2>
          <p class="body-text">
            创办于 1982 年，是记录我国新闻事业发展变化的大型资料性年刊，也是我国唯一一本新闻传播类综合性年刊。截至 2017 年底，已连续出版 36 卷。
          </p>
          <div class="support-grid">
            <figure class="support-figure support-figure--narrow">
              <img :src="images.cover1982" alt="《中国新闻年鉴》1982 年卷创刊号" />
              <figcaption>《中国新闻年鉴》1982 年卷创刊号</figcaption>
            </figure>
            <figure class="support-figure support-figure--wide">
              <img :src="images.collection" alt="历年《中国新闻年鉴》" />
              <figcaption>历年《中国新闻年鉴》</figcaption>
            </figure>
          </div>
        </div>

        <div class="aside-stack">
          <figure class="aside-figure">
            <img :src="images.berkeley" alt="美国加州大学伯克利分校图书馆藏有《中国新闻年鉴》" />
            <figcaption>美国加州大学伯克利分校图书馆藏有《中国新闻年鉴》</figcaption>
          </figure>
          <figure class="aside-figure">
            <img :src="images.award" alt="《中国新闻年鉴》获全国年鉴编校质量一等奖" />
            <figcaption>《中国新闻年鉴》获全国年鉴编校质量一等奖</figcaption>
          </figure>
        </div>
      </div>
    </section>

    <section class="page-section page-section--feature">
      <figure class="feature-figure">
        <img :src="images.firstConference1982" alt="1982 年 11 月《中国新闻年鉴》第一届全国工作会议在北京召开" />
        <figcaption>1982 年 11 月，《中国新闻年鉴》第一届全国工作会议在北京召开</figcaption>
      </figure>
    </section>

    <section class="page-section">
      <div class="timeline-grid timeline-grid--three">
        <figure class="timeline-figure">
          <img :src="images.editorialBoard1992" alt="1992 年 11 月《中国新闻年鉴》编委会委员合影" />
          <figcaption>1992 年 11 月，《中国新闻年鉴》编委会委员合影</figcaption>
        </figure>
        <figure class="timeline-figure">
          <img :src="images.chongqing2002" alt="2002 年 1 月《中国新闻年鉴》第二十一届全国工作会议代表合影" />
          <figcaption>2002 年 1 月，在重庆市召开的《中国新闻年鉴》第二十一届全国工作会议代表合影</figcaption>
        </figure>
        <figure class="timeline-figure timeline-figure--wide">
          <img :src="images.huaian2006" alt="2006 年 10 月《中国新闻年鉴》第二十六届全国工作会议代表合影" />
          <figcaption>2006 年 10 月，在江苏省淮安市召开的《中国新闻年鉴》第二十六届全国工作会议代表合影</figcaption>
        </figure>
      </div>
    </section>

    <section class="page-section page-section--timeline">
      <div class="timeline-grid timeline-grid--top">
        <figure class="timeline-figure">
          <img :src="images.wenzhou2008" alt="2008 年 11 月《中国新闻年鉴》第二十八届全国工作会议代表合影" />
          <figcaption>2008 年 11 月，在浙江省温州市召开的《中国新闻年鉴》第二十八届全国工作会议代表合影</figcaption>
        </figure>
        <figure class="timeline-figure">
          <img :src="images.xichang2012" alt="2012 年 11 月《中国新闻年鉴》第三十二届全国工作会议在四川省西昌市召开" />
          <figcaption>2012 年 11 月，《中国新闻年鉴》第三十二届全国工作会议在四川省西昌市召开</figcaption>
        </figure>
      </div>

      <div class="timeline-grid timeline-grid--bottom">
        <figure class="timeline-figure">
          <img :src="images.shijiazhuang2016" alt="2016 年 4 月《中国新闻年鉴》第三十五届全国工作会议代表合影" />
          <figcaption>2016 年 4 月，在河北省石家庄市召开的《中国新闻年鉴》第三十五届全国工作会议代表合影</figcaption>
        </figure>
        <figure class="timeline-figure">
          <img :src="images.jinyun2017" alt="2017 年 4 月《中国新闻年鉴》第三十六届全国工作会议代表合影" />
          <figcaption>2017 年 4 月，在浙江省缙云县召开的《中国新闻年鉴》第三十六届全国工作会议代表合影</figcaption>
        </figure>
        <figure class="timeline-figure">
          <img :src="images.honghe2018" alt="2018 年 4 月《中国新闻年鉴》第三十七届全国工作会议代表合影" />
          <figcaption>2018 年 4 月，在云南省红河市召开的《中国新闻年鉴》第三十七届全国工作会议代表合影</figcaption>
        </figure>
      </div>
    </section>
  </WebChapterTemplate>
</template>

<script>
import WebChapterTemplate from '@/components/WebChapterTemplate.vue';

export default {
  name: 'NewLanhuZhongguoxinwennianjian',
  components: {
    WebChapterTemplate
  },
  data() {
    return {
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      images: {
        cover1982: require('./assets/p62-cover-1982.jpg'),
        collection: require('./assets/p62-yearbooks-collection.jpg'),
        berkeley: require('./assets/p62-berkeley-library.jpg'),
        award: require('./assets/p62-award-certificate.jpg'),
        firstConference1982: require('./assets/p63-first-conference-1982.jpg'),
        editorialBoard1992: require('./assets/p64-editorial-board-1992.jpg'),
        chongqing2002: require('./assets/p64-chongqing-2002.jpg'),
        huaian2006: require('./assets/p64-huaian-2006.jpg'),
        wenzhou2008: require('./assets/p65-wenzhou-2008.jpg'),
        xichang2012: require('./assets/p65-xichang-2012.jpg'),
        shijiazhuang2016: require('./assets/p65-shijiazhuang-2016.jpg'),
        jinyun2017: require('./assets/p65-jinyun-2017.jpg'),
        honghe2018: require('./assets/p65-honghe-2018.jpg')
      }
    };
  }
};
</script>

<style scoped>
.page-section {
  margin-bottom: 48px;
}

.page-section:last-child {
  margin-bottom: 0;
}

.page-section--intro {
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(179, 145, 101, 0.2);
}

.section-title {
  margin: 0 0 16px;
  color: #f25c19;
  font-size: 24px;
  line-height: 1.4;
  font-weight: 700;
  font-family: 'Songti SC', 'STSong', 'Noto Serif SC', serif;
}

.body-text {
  margin: 0 0 20px;
  color: #231f20;
  font-size: 15px;
  line-height: 1.9;
  text-align: justify;
  text-indent: 2em;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.intro-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(280px, 0.72fr);
  gap: 24px;
  align-items: start;
}

.support-grid,
.timeline-grid,
.timeline-grid--top,
.timeline-grid--bottom {
  display: grid;
  gap: 18px;
}

.support-grid {
  grid-template-columns: minmax(130px, 0.32fr) minmax(0, 1fr);
  align-items: end;
}

.aside-stack {
  display: grid;
  gap: 18px;
}

.support-figure,
.aside-figure,
.timeline-figure,
.feature-figure {
  margin: 0;
}

.support-figure img,
.aside-figure img,
.timeline-figure img,
.feature-figure img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 8px 22px rgba(45, 33, 16, 0.08);
}

.support-figure figcaption,
.aside-figure figcaption,
.timeline-figure figcaption,
.feature-figure figcaption {
  margin-top: 10px;
  color: #6f6253;
  font-size: 12px;
  line-height: 1.6;
  text-align: center;
}

.support-figure--narrow img {
  border: 1px solid rgba(179, 145, 101, 0.22);
}

.feature-figure {
  padding: 22px;
  background: linear-gradient(180deg, rgba(250, 246, 240, 0.96), rgba(255, 255, 255, 1));
  border: 1px solid rgba(179, 145, 101, 0.18);
  border-radius: 10px;
}

.feature-figure figcaption {
  font-size: 13px;
}

.timeline-grid--three {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: start;
}

.timeline-figure--wide {
  grid-column: 1 / -1;
}

.page-section--timeline {
  padding: 28px 24px 12px;
  border-radius: 10px;
  background:
    linear-gradient(135deg, rgba(244, 235, 221, 0.5), rgba(255, 255, 255, 0) 45%),
    linear-gradient(180deg, rgba(255, 250, 244, 0.95), rgba(255, 255, 255, 1));
  border: 1px solid rgba(179, 145, 101, 0.16);
}

.timeline-grid--top {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-bottom: 20px;
}

.timeline-grid--bottom {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

@media (max-width: 1024px) {
  .intro-grid {
    grid-template-columns: 1fr;
  }

  .timeline-grid--bottom {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .support-grid,
  .timeline-grid--three,
  .timeline-grid--top,
  .timeline-grid--bottom {
    grid-template-columns: 1fr;
  }

  .page-section--timeline {
    padding: 20px 0 0;
    background: none;
    border: 0;
  }

  .feature-figure {
    padding: 14px;
  }
}
</style>
